import { I18n } from '~/constants/I18n';

export type DocumentTitleEntry = {
  id: string;
  /** `undefined` while the page is still loading its title. */
  title: string | undefined;
  isFallback: boolean;
};

/**
 * Latest page title wins; fallback titles (e.g. the workspace name from the layout) only apply when no page title is registered.
 * An entry still loading its title shows the generic title, so a page title loading does not flash the fallback first.
 */
export const getActiveDocumentTitle = (entries: DocumentTitleEntry[]) => {
  const entry = entries.findLast(({ isFallback }) => !isFallback) ?? entries.findLast(({ isFallback }) => isFallback);

  if (!entry) {
    return undefined;
  }

  return entry.title ?? I18n.basePageShortTitle;
};
